import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Drawer from '../../../../components/Drawer';

import material_styles from './drawer_styles/material_styles';
import GrupoSimples from './Grupos/GrupoSimples';
import GrupoGrade from './Grupos/GrupoGrade';
import GrupoPizza from './Grupos/GrupoPizza';

import { AddButton } from '../styles';
import { DrawerTitle } from './drawer_styles';

interface DrawerProps {
  isMateriaPrima: boolean;
  isClosed?: boolean;
}

const Drawers: React.FC<DrawerProps> = ({ isMateriaPrima, isClosed }) => {
  const classes = material_styles();

  return (
    <Drawer
      buttonTitle="Adicionar Grupo"
      openButton={AddButton}
      isClosed={isClosed}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DrawerTitle>
              <h1>Novo Grupo</h1>
              {!isMateriaPrima ? (
                <span>
                  Selecione o modelo de grupo para dividir seus produtos.
                </span>
              ) : (
                <span>Crie um grupo para organizar suas matérias primas</span>
              )}
            </DrawerTitle>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingBot}>
            <GrupoSimples isMateriaPrima={isMateriaPrima} />
          </Grid>

          {!isMateriaPrima && (
            <>
              {/* <Grid item xs={12} className={classes.noPaddingBot}>
                <GrupoGrade />
              </Grid> */}

              <Grid item xs={12} className={classes.noPaddingBot}>
                <GrupoPizza />
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Drawer>
  );
};

export default Drawers;
